import { render } from "./NuevoPedidoRecarga.vue?vue&type=template&id=983c2028&scoped=true"
import script from "./NuevoPedidoRecarga.vue?vue&type=script&lang=js"
export * from "./NuevoPedidoRecarga.vue?vue&type=script&lang=js"

import "./NuevoPedidoRecarga.vue?vue&type=style&index=0&id=983c2028&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-983c2028"]])

export default __exports__